module.exports = __webpack_public_path__ + "static/img/GooglePay_Lockup.max-1000x1000.a887203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GooglePay_Lockup.max-1000x1000.png
// module id = moWD
// module chunks = 3